import React, { useEffect } from 'react';

const ReservationWidget: React.FC = () => {
  useEffect(() => {
    if (document.querySelector('script[data-business-id="6a2143926a6b8bfe1ee1665d"]')) return;
    const script = document.createElement('script');
    script.src = 'https://book.restomanager.net/widget.js';
    script.setAttribute('data-base-url', 'https://book.restomanager.net');
    script.setAttribute('data-business-id', '6a2143926a6b8bfe1ee1665d');
    script.setAttribute('data-widget-type', 'floatingWidget');
    script.setAttribute('data-floating', 'true');
    document.body.appendChild(script);
  }, []);

  return null;
};

export default ReservationWidget;
